"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./DownloadButton.css");
var Button_1 = require("../Button");
var Icon_1 = require("../../icon/Icon");
var native_1 = require("../../../utils/native");
var DownloadButtonComp = function (_a, ref) {
    var _b = _a.children, children = _b === void 0 ? 'Download' : _b, props = __rest(_a, ["children"]);
    return (React.createElement(Button_1.ButtonFR, __assign({}, props, { ref: ref, className: classnames_1.default('DownloadButton', props.className), theme: Button_1.ButtonTheme.blueLabel }),
        React.createElement(Icon_1.Icon, { type: Icon_1.IconType.download }),
        children && React.createElement("span", { className: 'DownloadButton_content' }, children)));
};
exports.DownloadButtonFR = React.forwardRef(DownloadButtonComp);
exports.DownloadButton = React.memo(exports.DownloadButtonFR);
exports.downloadWithBase64String = function (baseString, filename) {
    var encodedUri = encodeURI(baseString);
    var a = document.createElement('a');
    a.href = encodedUri;
    a.download = filename;
    a.target = '_blank';
    document.body.appendChild(a); //append to work in firefox
    a.click();
    a.remove();
};
exports.downloadOrOpenBlob = function (blob, filename, open, sendToIOSProps) {
    if (open === void 0) { open = false; }
    if (sendToIOSProps === void 0) { sendToIOSProps = {}; }
    if (native_1.isNativeIOS) {
        //send to ios
        var reader_1 = new FileReader();
        reader_1.onload = function () {
            var base64 = reader_1.result
                ? reader_1.result.split(',')[1]
                : '';
            native_1.sendToIOS('nativeOpenDocument', __assign(__assign({}, sendToIOSProps), { base64: base64, type: blob.type, name: filename }));
        };
        reader_1.readAsDataURL(blob);
    }
    else if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //if IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
    }
    else {
        var url = window.URL.createObjectURL(blob);
        if (open) {
            window.open(url);
        }
        else {
            var a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.target = '_blank';
            document.body.appendChild(a); //append to work in firefox
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        }
    }
};
